import { Node } from "@tiptap/core";

/**
 * Minimal hard-break node (<br>). Shift+Enter inserts one in any field;
 * single-line (inline mode) fields also remap plain Enter to it via
 * InlineEnterAsBreak so a heading can never split into paragraphs.
 */
export const HardBreakNode = Node.create({
  name: "hardBreak",
  inline: true,
  group: "inline",
  selectable: false,

  parseHTML() {
    return [{ tag: "br" }];
  },

  renderHTML() {
    return ["br"];
  },

  addKeyboardShortcuts() {
    return {
      "Shift-Enter": () =>
        this.editor.commands.insertContent({ type: this.name }),
    };
  },
});
